import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";
import newsService from "../../services/news/newsService";
import UploadModules from "../../constants/uploadModules";

import "./News.css";

export default function NewsForm() {

    const navigate = useNavigate();

    const { id } = useParams();

    const isEdit = !!id;

    const [loading, setLoading] = useState(false);

    const [form, setForm] = useState({

        newsTitle: "",

        metaTitle: "",

        metaDescription: "",

        newsShortDescription: "",

        newsDescription: "",

        newsDate: "",

        newsImage: "",

        displayOrder: 0,

        isActive: true

    });

    useEffect(() => {

        if (isEdit) {

            loadNews();

        }

    }, []);

    const loadNews = async () => {

        try {

            setLoading(true);

            const response = await newsService.getById(id);
            const data = response.data;

            if (response.success) {

                const data = response.data;

                setForm({

                    newsTitle: data.newsTitle || "",

                    metaTitle: data.metaTitle || "",

                    metaDescription: data.metaDescription || "",

                    newsShortDescription: data.newsShortDescription || "",

                    newsDescription: data.newsDescription || "",

                    newsDate: data.newsDate
                        ? data.newsDate.substring(0, 10)
                        : "",

                    newsImage: data.newsImage || "",

                    displayOrder: data.displayOrder || 0,

                    isActive: data.isActive

                });

            }

        }
        catch (error) {

            console.log(error);

        }
        finally {

            setLoading(false);

        }

    };

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setForm({

            ...form,

            [name]: type === "checkbox" ? checked : value

        });

    };


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.newsTitle.trim()) {

            toast.error("News Title is required.");

            return;

        }

        try {

            setLoading(true);

            let response;

            if (isEdit) {

                response = await newsService.update(id, form);

            }
            else {

                response = await newsService.create(form);

            }

            if (response.success) {

                toast.success(response.message);

                navigate("/news");

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }
        finally {

            setLoading(false);

        }

    };
    return (

        <AdminLayout>

            <div className="page-header">

                <h2>
                    {isEdit ? "Edit News" : "Add News"}
                </h2>

            </div>

            <div className="card">

                <form onSubmit={handleSubmit}>

                    <div className="card-body">

                        <div className="row g-3">

                            {/* News Title */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    News Title <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="newsTitle"
                                    value={form.newsTitle}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* News Date */}
                            <div className="col-lg-3">

                                <label className="form-label">
                                    News Date
                                </label>

                                <input
                                    type="date"
                                    className="form-control"
                                    name="newsDate"
                                    value={form.newsDate}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Display Order */}
                            <div className="col-lg-3">

                                <label className="form-label">
                                    Display Order
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="displayOrder"
                                    value={form.displayOrder}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Meta Title */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Meta Title
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="metaTitle"
                                    value={form.metaTitle}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Meta Description */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    Meta Description
                                </label>

                                <textarea
                                    rows="1"
                                    className="form-control"
                                    name="metaDescription"
                                    value={form.metaDescription}
                                    onChange={handleChange}
                                />

                            </div>


                            {/* Short Description */}
                            <div className="col-6">

                                <label className="form-label">
                                    Short Description
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="newsShortDescription"
                                    value={form.newsShortDescription}
                                    onChange={handleChange}
                                />

                            </div>

                            {/* Description */}
                            <div className="col-6">

                                <label className="form-label">
                                    Description
                                </label>

                                <textarea
                                    rows="4"
                                    className="form-control"
                                    name="newsDescription"
                                    value={form.newsDescription}
                                    onChange={handleChange}
                                />

                            </div>
                            {/* Image */}
                            <div className="col-lg-6">

                                <label className="form-label">
                                    News Image
                                </label>

                                <ImageUploader
                                    module={UploadModules.NEWS}
                                    value={form.newsImage}
                                    onUpload={(path) =>
                                        setForm({
                                            ...form,
                                            newsImage: path
                                        })
                                    }
                                />

                            </div>


                            {/* Status */}
                            <div className="col-lg-2 d-flex align-items-end">

                                <div className="form-check mb-2">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isActive"
                                        name="isActive"
                                        checked={form.isActive}
                                        onChange={handleChange}
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="isActive"
                                    >
                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <hr />

                        <div className="d-flex justify-content-start gap-2">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate("/news")}
                            >
                                Cancel
                            </button>

                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : isEdit
                                        ? "Update"
                                        : "Save"}
                            </button>

                        </div>

                    </div>

                </form>

            </div>
        </AdminLayout>

    );

}